import {FC} from "react";
import {Table} from "semantic-ui-react";
import {NoResultsMessage} from "../../components/SystemMessages";

interface INoResultsProps {
    numberOfColumns: number;
    marginTop?: number;
}

const NoResultsTableBody: FC<INoResultsProps> = ({numberOfColumns, marginTop}) => {
    return (
        <Table.Body>
            <Table.Row colSpan={numberOfColumns}>
                <Table.Cell colSpan={numberOfColumns}>
                    <NoResultsMessage marginTop={marginTop} text="data" />
                </Table.Cell>
            </Table.Row>
        </Table.Body>
    );
};

export default NoResultsTableBody;
